interface LocationLike {
  pathname: string;
  search?: string;
  hash?: string;
}

interface LoginRedirectState {
  from?: LocationLike | null;
}

export function buildReturnTo(location: LocationLike): string {
  return `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`;
}

export function getCurrentBrowserPath(): string {
  return buildReturnTo(window.location);
}

export function getReturnToFromLoginLocation(
  location: LocationLike & { state?: unknown },
): string | undefined {
  const state = location.state as LoginRedirectState | null;
  const from = state?.from;
  if (from?.pathname) {
    return buildReturnTo(from);
  }

  const browserPath = getCurrentBrowserPath();
  if (browserPath.startsWith('/app')) {
    return browserPath;
  }

  return undefined;
}
